// extracted by mini-css-extract-plugin
module.exports = {"timer":"Insurgency_timer__3a69O","insurgecnyTooltip":"Insurgency_insurgecnyTooltip__1o9J6"};